import React from "react";
import {
  ChoiceGroup,
  DefaultButton,
  Dialog,
  DialogType,
  Dropdown,
  IChoiceGroupOption,
  Icon,
  IDropdownOption,
  Label,
  Link,
  MessageBar,
  MessageBarType,
  Panel,
  PanelType,
  PrimaryButton,
  ResponsiveMode,
  Spinner,
  SpinnerSize,
  TextField,
} from "office-ui-fabric-react";

import { OpenAIClient, AzureKeyCredential } from "@azure/openai";
// import { Web } from "sp-pnp-js";

import Select from "react-select";
import { SweetAlerts } from "./Global/SweetAlert";
import { customStyles, isStringValidated, sortAlphaNum } from "./Global/Constant";
import {
  downloadFileBlob,
  fetchRequestData,
  fetchRiskTaskRequestData,
  generateDocuments,
  getCluaseLibraryData,
  getFileById,
  saveDraftDocument,
  updateListData,
  updateListItem,
} from "../Utils/CommonFunctions";
import { CopilotExtractText } from "./Generators/CopilateTextExtractor";

let libraryData: any;
let initalMitigatedRisks = [];
const RequestRisks = () => {
  const FileURL = "";
  const AiStars : any = require("../../../assets/AiStars.png")
  const AzureAI: any = JSON.parse(localStorage.getItem("AzureAI") || "{}");
  const Copilot:any= JSON.parse(localStorage.getItem("Copilot")||"{}")
  const AzureAIValue = {
    ...AzureAI,
    AzureOpenAIToggle: true,
  };
  const AzureAITogleValue = AzureAIValue?.APIkey ? true : false;
  const [isClausePanelOpen, setisClausePanelOpen] = React.useState(false);
  const [selectedChoice, setSelectedChoice] = React.useState<string | null>(null);
  const [selectedClause, setselectedClause] = React.useState("");
  const [slectedRiskClause, setslectedRiskClause] = React.useState("");
  const [RiskComments, setRiskComments] = React.useState("");
  const [textchoices, settextchoices] = React.useState([]);
  const [contentNotFound, setContentNotFound] = React.useState(false);
  const [showAltClauseButton, setshowAltClauseButton] = React.useState({ single: true, all: false });
  const [conditionValue, setConditionValue] = React.useState<any>("");
  // const [showTextField, setShowTextFeild] = React.useState(false);
  const [AlternetClauseLoader, setAlternetClauseLoader] = React.useState(false);
  const [buttonUpdate, setbuttonUpdate] = React.useState("Update");
  const [buttonUpdateLoader, setbuttonUpdateLoader] = React.useState(false);
  const [updatedRiskData, setupdatedRiskData] = React.useState([]);
  const [RiskAnalysData, setRiskAnalysData] = React.useState([]);
  const [RiskTaskData, setRiskTaskData] = React.useState<any>({});
  const [RequestItem, setRequestItem] = React.useState<any>({});
  const [showChevronIcon, setShowChevronIcon] = React.useState({ AI: "down", Lib: "down", openDialog: "yes" });
  const [updatedClause, setupdatedClause] = React.useState("");
  const [showAll, setshowAll] = React.useState(false);
  const { SweetAlert: SweetAlertUpdate, SweetPrompt: SweetPromptUpdate } = SweetAlerts("#SweetAlertUpdate");
   const { SweetAlert: SweetAlertRisk, SweetPrompt: SweetPromptRisk } = SweetAlerts("#SweetAlertMainTab");
  const [selectedLibClause, setSelectedLibClause] = React.useState({ clauseType: "", Tags: "" });
  const [showErrors, setShowErrors] = React.useState({ clauseType: false, tags: false });
  const [showClauseModal, setshowClauseModal] = React.useState({
    inPanel: false,
    matchFound: true,
  });
  // const [message, setMessage] = React.useState({
  //       defaultmessages:[], altmessages:[]
  //     })
  const [clauseFromLib, setclauseFromLib] = React.useState([]);
  const [isRiskFromTaskPanel, setisRiskFromTaskPanel] = React.useState(false);
  const [clauseTypesOptions, setClauseTypesOptions] = React.useState([]);
  const [selectedLibChoice, setSelectedLibChoice] = React.useState({ key: "", text: "" });
  const [selectedRowData, setselectedRowData] = React.useState<any>({});
  const [IsShowUpdate, setIsShowUpdate] = React.useState<any>(false);
  const [LegalUserRiskData, setLegalUserRiskData] = React.useState<any>({
    Comments: "",
    Status: null,
  });
  const statusOptions: IDropdownOption[] = [
    { key: "Not Started", text: "Not Started" },
    { key: "In Progress", text: "In Progress" },
    { key: "Reviewed", text: "Reviewed" },
  ];

  const mitigateStatusOptions: IDropdownOption[] = [
    { key: "Reviewed", text: "Reviewed" },
    { key: "Reviewed - No Action Required", text: "Reviewed - No Action Required" },
    { key: "Mitigated", text: "Mitigated" },
  ];

  React.useEffect(() => {
    initalMitigatedRisks = [];
    fetchData("Initial");
  }, []);
  const fetchData = async (fetchType) => {
    const reqGuid: any = localStorage.getItem("RequestDraftFileName");
    const riskGUID: any = localStorage.getItem("RiskGUID");
    const RquestRiskGUID: any = localStorage.getItem("RequestRiskGUID");
    const requestItem: any = await fetchRequestData(reqGuid);
    const riskTaskItem = await fetchRiskTaskRequestData(riskGUID);
    // console.log(riskTaskItem, "riskTaskItem");
    const requestData = requestItem[0];
    // console.log(riskGUID, reqGuid, requestItem, "AllData");
    const RiskAnalysis = JSON.parse(requestData?.RiskAnalysis || "[]");
    const targetGUID = riskGUID != "null" ? riskGUID : RquestRiskGUID;
    const currentRiskData = RiskAnalysis?.filter((item) => item.GUID === targetGUID);

    // console.log(riskGUID, "riskGUID?true:false");
    // console.log(currentRiskData, "currentRiskData");
    setisRiskFromTaskPanel(riskGUID !== "null");
    setRiskTaskData(riskTaskItem?.length ? riskTaskItem[0] : {});
    setRequestItem(requestItem?.length ? requestItem[0] : {});
    setupdatedRiskData(RiskAnalysis);
    setRiskAnalysData(RiskAnalysis?.filter((item) => item.Status !== "Mitigated"));
    if (fetchType) {
      initalMitigatedRisks = RiskAnalysis?.filter((item) => item.Status === "Mitigated");
    }

    if (currentRiskData?.length) {
      setselectedRowData(currentRiskData[0]);
      setselectedClause(currentRiskData[0]?.Clause);
      setslectedRiskClause(currentRiskData[0]?.Clause);
      searchInDraft(currentRiskData[0]?.Clause);
      fetchClauseData();
    }
  };

  const searchInDraft = async (text: string) => {
    await Word.run(async (context) => {
      const searchResults = context.document.body.search(text, {
        matchCase: false,
        matchWholeWord: false,
        matchWildcards: false,
      });

      searchResults.load("items, length");
      await context.sync();

      if (searchResults.items.length === 0) {
        // console.log("Text not found.");
        return;
      }

      // Highlight all found results
      for (const range of searchResults.items) {
        range.font.highlightColor = "#FFFF00"; // yellow highlight
      }

      // Select the first found range to move cursor and scroll view
      searchResults.items[0].select("Start");

      await context.sync();
    });
  };

  const handleChoiceChange = (_, option) => {
    if (option) {
      setSelectedChoice(option.key);
      setselectedClause(option.text);
      localStorage.setItem('RequestRiskGUID',option.key)
      // setshowAltClauseButton(true)
      setshowAltClauseButton((prev) => ({ ...prev, all: true }));
    }
  };
  const onAllClick = () => {
    setselectedClause("");
    setshowAll(true);
  };
  const onRiskClauseClick = () => {
    setselectedClause(selectedRowData.Clause);
    setshowAll(false);
  };
  const AltClauseToggle = (type) => {
    if (type == "Lib") {
      if (showChevronIcon.AI == "up" && showChevronIcon.Lib == "up") {
        setShowChevronIcon((prev) => ({ ...prev, Lib: "down" }));
      } else if (showChevronIcon.AI == "up" && showChevronIcon.Lib == "down") {
        setShowChevronIcon((prev) => ({ ...prev, Lib: "up" }));
      } else if (showChevronIcon.AI == "down" && showChevronIcon.Lib == "up") {
        setShowChevronIcon((prev) => ({ ...prev, AI: "up", Lib: "down" }));
      } else {
        setShowChevronIcon({ AI: "up", Lib: "up", openDialog: "no" });
      }
      // }
    } else if (type == "AI") {
      if (showChevronIcon.AI == "up" && showChevronIcon.Lib == "up") {
        setShowChevronIcon((prev) => ({ ...prev, AI: "down" }));
      } else if (showChevronIcon.AI == "down" && showChevronIcon.Lib == "up") {
        setShowChevronIcon((prev) => ({ ...prev, AI: "up" }));
      } else if (showChevronIcon.AI == "up" && showChevronIcon.Lib == "down") {
        setShowChevronIcon((prev) => ({ ...prev, AI: "down", Lib: "up" }));
      } else {
        setShowChevronIcon({ AI: "up", Lib: "up", openDialog: "no" });
      }
    }
  };
  const handleOpenPanel = (type) => {
    if (type == "single") {
      setSelectedChoice(selectedRowData.GUID);
    }
    selectClause();
    setisClausePanelOpen(true);
    // setshowAltClauseButton(true)
    setshowAltClauseButton((prev) => ({ ...prev, all: true }));
    // console.log(AzureAITogleValue, "AzureAITogleValue");
    if (AzureAITogleValue) {
      setAlternetClauseLoader(true);
      fetchResponses2(selectedClause);
    }
  };
  const handlePanelClose = () => {
    setisClausePanelOpen(false);
    // setShowTextFeild(false)
    setSelectedChoice(null);
    settextchoices([]);
    // setshowAltClauseButton(false)
    setshowAltClauseButton({ single: true, all: false });
    setConditionValue("");
    setShowChevronIcon({ AI: "down", Lib: "down", openDialog: "yes" });
    setclauseFromLib([]);
    setSelectedLibChoice({ key: "", text: "" });
  };

  const fetchResponses2 = async (selectiontext) => {
    // setshowAltClauseButton(false);
    setshowAltClauseButton((prev) => ({ ...prev, all: false }));
    // console.log(AzureAIValue, "AzureAIValue fetch");
    const endpoint = AzureAIValue?.Endpoint || "";
    const azureApiKey = AzureAIValue?.APIkey || "";
    const deploymentId = AzureAIValue?.DeploymentName || "";
    // console.log(endpoint);

    try {
      // console.log("try");
      const client = new OpenAIClient(endpoint, new AzureKeyCredential(azureApiKey));

      let array = [
        { role: "user", content: selectiontext },
        {
          role: "system",
          content:
            "You are a helpful assistant who provides concise and direct answers. Avoid stating that you are an AI language model.",
        },
        { role: "system", content: "Please rephrase the content to sound more professional." },
        {
          role: "system",
          content:
            "Generate a single alternative version of the content with a unique sentence structure while maintaining the original meaning.",
        },
      ];

      let uniqueResponses = new Set();
      let allItems1ForAI = [];
      // console.log("uniqueResponses", uniqueResponses);
      // Fetch exactly 4 unique responses
      if(AzureAI?.AzureOpenAIToggle){
      while (uniqueResponses.size < 4) {
        const result = await client.getChatCompletions(deploymentId, array, {
          temperature: 0.7, // Higher for better variation
          maxTokens: 200,
        });
        // console.log("result", result);
        let responseText = result?.choices?.[0]?.message?.content?.trim();
        if (responseText && !uniqueResponses.has(responseText)) {
          uniqueResponses.add(responseText);
          allItems1ForAI.push({
            key: responseText,
            text: responseText,
            Message: responseText,
          });
        }
      }
    } else if(Copilot?.CopilotToggle === "Yes"){
      const result = await CopilotExtractText(selectiontext, "Alternate Clause");
      try {
        const parsed = JSON.parse(result);
        if (parsed) {
          setContentNotFound(false);
          for (const choice of parsed) {
            let finaltemp = {
              key: choice,
              text: choice,
              Message: choice,
            };
            allItems1ForAI.push(finaltemp);
          }
        }
      } catch (e) {
        setContentNotFound(true);
        // console.log("Non result:", result);
      }
    }

      // console.log(allItems1ForAI, "textchoices");
      settextchoices(allItems1ForAI);
    } catch (err) {
      // console.log(err);
      setAlternetClauseLoader(false);
    } finally {
      // setshowAltClauseButton(false);
      setshowAltClauseButton((prev) => ({ ...prev, all: true }));
      setAlternetClauseLoader(false);
    }
  };

  function onChangeConditions(_, option: IChoiceGroupOption): void {
    if (option) {
      setConditionValue(option.text as string);
      setupdatedClause(option.text as string);
      setslectedRiskClause(option.text as string);
      // setShowChevronIcon({AI:"down", Lib:"down"})
      // setShowTextFeild(false)
    }
  }

  function updatechoicetext() {
    if (selectedClause && conditionValue) {
      const newText = conditionValue;
      // docEditor.search.findAll(selectedClause);
      SweetPromptUpdate("warning", `Are you sure you want to update in contract?`).then((result) => {
        if (result.isConfirmed) {
        }
      });

      // Clear selections
    }
  }
  const updateRiskAnasysis = (updatedRiskAnalysis) => {
    // const updatedData = updatedRiskData.map((item) =>
    //   item.GUID === selectedChoice ? { ...item, Status: "Mitigated", UpdatedClause: updatedClause } : item
    // );
    setupdatedRiskData(updatedRiskAnalysis);

    setRiskAnalysData(updatedRiskAnalysis.filter((item) => item.Status !== "Mitigated"));
  };

  async function selectClause() {
    await Word.run(async (context) => {
      const searchResults = context.document.body.search(selectedClause, {
        matchCase: false,
        matchWholeWord: false,
        matchWildcards: false,
      });

      searchResults.load("items, length");
      await context.sync();

      if (searchResults.items.length === 0) {
        // console.log("Text not found.");
        return;
      }

      // First, clear any existing highlight on all found ranges
      for (const range of searchResults.items) {
        range.font.highlightColor = ""; // remove highlight
      }

      await context.sync(); // sync to apply removal of highlights first

      // Now, apply yellow highlight to all found results
      for (const range of searchResults.items) {
        range.font.highlightColor = "#FFFF00"; // yellow highlight
      }

      // Select the start of the first found range
      searchResults.items[0].select("Start");

      await context.sync();
    });
  }

  const handleTextFieldChange = (e) => {
    setConditionValue(e.target.value);
    setupdatedClause(e.target.value);
    setslectedRiskClause(e.target.value);
  };

  async function fetchClauseData() {
    await getCluaseLibraryData()
      .then((data: any) => {
        libraryData = data;
        //  const allClauses = data?.map((item) => item.clauseName)
        const clauseTypes = Array.from(new Set(data.map((i) => i.clauseType))).map((clauseType) => ({
          label: clauseType,
          value: clauseType,
        }));
        setClauseTypesOptions(clauseTypes?.sort(sortAlphaNum));
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const handleClauseChange = (e, c) => {
    let value;
    if (c === "clauseType") {
      value = e?.value;
    } else if (c === "Tags") {
      value = e.target.value;
    }

    setSelectedLibClause((prevState) => ({
      ...prevState,
      [c]: value,
    }));
  };

  const handleSubmit = () => {
    const errors = {
      clauseType: !selectedLibClause.clauseType.trim(),
      tags: !selectedLibClause.Tags.trim(),
    };
    setShowErrors(errors);
    if (!errors.clauseType && !errors.tags) {
      fetchMessages();
    }
  };
  const fetchMessages = () => {
    const { clauseType, Tags } = selectedLibClause;
    if (clauseType && Tags) {
      const selectedData =
        libraryData.filter(
          (i) => i.tags.toLowerCase().trim()?.includes(Tags.toLowerCase()) && i.clauseType === clauseType
        ) || [];
      // console.log(selectedData)
      if (selectedData?.length) {
        const choices = selectedData[0].message.map((item) => ({
          key: item.id,
          text: item.rted.replace(/<[^>]*>/g, " "),
          message: item.rted.replace(/<[^>]*>/g, " "),
        }));
        setclauseFromLib(choices);
        setshowClauseModal({ inPanel: false, matchFound: true });
        setSelectedLibClause({ clauseType: "", Tags: "" });
        setShowChevronIcon({ AI: "up", Lib: "down", openDialog: "no" });
      } else {
        setshowClauseModal({ inPanel: false, matchFound: false });
        SweetAlertUpdate("error", "Match not found!");
        setSelectedLibClause({ clauseType: "", Tags: "" });
      }
    }
  };

  const handleChoiceChangefromLib = (_, option) => {
    if (option) {
      // setSelectedChoice(option.key);
      setSelectedLibChoice({ key: option.key, text: option.text });
      // setshowAltClauseButton(true)
      setConditionValue(option.text);
      setslectedRiskClause(option.text);

      // setShowTextFeild(false)
    }
  };

  const updateRiskTask = async () => {
 
    if (!selectedRowData?.Status) {
      SweetAlertRisk("error", "Please select the status");
    } else if (!RiskComments) {
      SweetAlertRisk("error", "Please enter comments");
    } else {
      // console.log(RiskTaskData, "RiskTaskData");
      const finaltemp = {
        Status: selectedRowData?.Status == "Reviewed" ? "Completed" : selectedRowData?.Status,
      };
      await updateListItem("CLM365ContractTasks", finaltemp, RiskTaskData?.ID)
        .then(async (value) => {
          if (value) {
            const riskGUID: any = localStorage.getItem("RiskGUID") || "";
            // console.log(RequestItem, "RequestItem");
            const Activity_logs = JSON.parse(RequestItem?.Activity_Log || "[]");
            const RiskAnalysis = JSON.parse(RequestItem?.RiskAnalysis || "[]");
            const updatedRiskAnalysis = RiskAnalysis.map((item) =>
              item.GUID === riskGUID ? { ...item, Status: "Reviewed", Remarks: RiskComments } : item
            );
            // let highlightHTML;
            // if (slectedRiskClause !== selectedClause) {
            //   const exisitingText = `<p>Risk Clause: <span style="color: rgb(0, 0, 0);">${selectedClause}</span><span style="color: rgb(0, 0, 0);">&nbsp;</span></p>`;
            //   const slectedText = `<p>Selected Clause: <span style="color: rgb(0, 0, 0);">${slectedRiskClause}</span><span style="color: rgb(0, 0, 0);">&nbsp;</span></p>`;

            const highlightHTML = `<p>Risk Clasuse: <span style="color: rgb(0, 0, 0);">${selectedClause}</span><span style="color: rgb(0, 0, 0);">&nbsp;</span></p>`;
            // }
            const commentHTML = RiskComments ? `<p>Comments: ${RiskComments}</p>` : "";
            const fullHTML = highlightHTML + commentHTML;
            const uriCOmponent = encodeURIComponent(fullHTML);
            const currentUserDetails = JSON.parse(localStorage.getItem("CurrentUser") || "{}");
            const reviewActivity = {
              Activity: "Risk Task Completed",
              Description: `Risk task completed by ${currentUserDetails?.currentUserName}`,
              CreatedOn: new Date(),
              CreatedBy: currentUserDetails?.currentUserName,
              CreatedByEmail: currentUserDetails?.currentUserEmail,
              Reasons: "",
              Remarks: uriCOmponent,
              Attachments: "",
              Approvers: [],
              Originator: [currentUserDetails?.currentUserName],
              receivedUser: [],
              Contract_Type: "",
            };
            Activity_logs.push(reviewActivity);
            const finalRequestTemp = {
              Activity_Log: JSON.stringify(Activity_logs),
              RiskAnalysis: JSON.stringify(updatedRiskAnalysis),
            };
            await updateListData(RequestItem?.Id, finalRequestTemp, "CLM365Request");
          }
        })
        .then(() => {
          fetchData("update");
          SweetAlertRisk("success", "Submitted Successfully!");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const updateRiskMitigate = () => {
    if (!LegalUserRiskData?.Status) {
      SweetAlertUpdate("error", "Please select the status");
    } else if (!LegalUserRiskData?.Comments) {
      SweetAlertUpdate("error", "Please enter comments");
    } else {
      SweetPromptUpdate("warning", `Are you sure you want to update in contract?`).then((result) => {
        if (result.isConfirmed) {
          updateDocument();
        }
      });
    }
  };

  const updateDocument = async () => {
    await searchAndReplaceText(selectedClause, conditionValue);
    const riskGUID: any = localStorage.getItem("RequestRiskGUID") || "";
    // console.log(RequestItem, "RequestItem");
    const RiskAnalysis = JSON.parse(RequestItem?.RiskAnalysis || "[]");
    setIsShowUpdate((prev) => prev || LegalUserRiskData?.Status === "Mitigated");
    const updatedRiskAnalysis = RiskAnalysis.map((item) =>
      item.GUID === riskGUID
        ? {
            ...item,
            Status: LegalUserRiskData?.Status,
            Remarks: LegalUserRiskData?.Comments,
            UpdatedClause: updatedClause,
          }
        : item
    );
    const finalRequestTemp = {
      RiskAnalysis: JSON.stringify(updatedRiskAnalysis),
    };
    await updateListData(RequestItem?.Id, finalRequestTemp, "CLM365Request");
    setLegalUserRiskData({Comments: "", Status: null})
    SweetAlertUpdate("success", "Updated Successfully!").then(() => {
      updateRiskAnasysis(updatedRiskAnalysis);
      setTimeout(() => {
        handlePanelClose();
        setshowAltClauseButton((prev) => ({ ...prev, single: false }));
      }, 1000);
    });
  };

  const searchAndReplaceText = async (text: string, replaceText: string) => {
    await Word.run(async (context) => {
      const searchResults = context.document.body.search(text, {
        matchCase: false,
        matchWholeWord: false,
        matchWildcards: false,
      });

      searchResults.load("items");
      await context.sync();

      if (searchResults.items.length === 0) {
        SweetAlertUpdate("error", "No matching text found in the contract.");
        setTimeout(() => {
          handlePanelClose();
        }, 1000);
        return;
      }

      for (const range of searchResults.items) {
        range.insertText(replaceText, Word.InsertLocation.replace);
        range.font.highlightColor = "#FFFF00"; // Highlight replaced text
      }

      await context.sync();
    });
  };

  const updateDraftDocument = async () => {
    // console.log(initalMitigatedRisks);
    const initialMitigatedGUIDs = initalMitigatedRisks?.map((ele) => ele.GUID) || [];
    const updatedMitigatedRisks = updatedRiskData?.filter((ele) => ele.Status === "Mitigated");
    const updatedUnMatchingRisks =
      updatedMitigatedRisks?.filter((risk) => !initialMitigatedGUIDs.includes(risk.GUID)) || [];
    // console.log(updatedUnMatchingRisks);
    const FileName: any = localStorage.getItem("RequestDraftFileName");
    // console.log(FileName,'FileName')
    const fileName=FileName.includes('docx')?FileName:`${FileName}.docx`
    const fileInfo = await getFileById(fileName);
    const serverRelativeUrl = fileInfo?.ServerRelativeUrl;

    if (!serverRelativeUrl) {
      console.error("No file found for:", FileName);
      return;
    }
    const fileBlob = await downloadFileBlob(serverRelativeUrl);
   const FileBlob=await generateDocuments(fileBlob, updatedUnMatchingRisks);

       const updatedFile = new File([FileBlob], RequestItem['File_Name'], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

    saveDraftDocument(RequestItem['File_Name'],updatedFile).then((c)=>{
        if(c){
    SweetAlertRisk('success','Document updated successfully!')
        }
    })


  };

  return (
    <>
      {RiskTaskData?.Status !== "Completed" || !isRiskFromTaskPanel ? (
        <div id="SweetAlertMainTab">
          <div id="MitigateDocEditorDiv8" className={"MitigateRightMainDiv"}>
            <div id="MitigateDocEditorDiv9" className={"MitigateRightDivHeader"}>
              <div id="MitigateDocEditorDiv10">
                <Label
                  className={!isRiskFromTaskPanel ? "MitigateRightDivHeaderLabel" : ""}
                  onClick={onRiskClauseClick}
                >
                  {showAll ? "Risk Clause(s)" : "Risk Clause"}
                </Label>
              </div>
              {!isRiskFromTaskPanel && (
                <div id="MitigateDocEditorDiv11">
                  <Label
                    // onClick={()=>{setshowAll(true)}}
                    className={"MitigateRightDivHeaderLabel"}
                    onClick={onAllClick}
                  >
                    {"All"}
                  </Label>
                </div>
              )}
            </div>
            {showAll && (
              <div
                id="MitigateDocEditorDiv12"
                className={"MitigateRightDivBody"}
                style={{ border: "1px solid #ddd", margin: "5px", height: "670px" }}
              >
                {RiskAnalysData?.length ? (
                  <ol id="MitigateDocEditorOl38" style={{ marginLeft: "-10px", paddingRight: "5px", marginTop: "0px" }}>
                    {RiskAnalysData.map((item, _) => {
                      const choiceOptions: IChoiceGroupOption[] = [{ key: item.GUID, text: item.Clause }];
                      return (
                        <div id="MitigateDocEditorDiv13" key={item.GUID} style={{ paddingTop: "10px" }}>
                          <li id="MitigateDocEditorLi40" style={{ color: "var(--layoutTextColor)" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>{item.Risk}</div>
                              <div
                                style={{
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  minWidth: "fit-content",
                                  color: ["Reviewed", "In Progress", "Reviewed - No Action Required"].includes(
                                    item.Status
                                  )
                                    ? "#ffaa44"
                                    : item.Status == "Mitigated"
                                    ? "#6bb700"
                                    : "#000",
                                }}
                              >
                                {item.Status}
                              </div>
                            </div>
                          </li>
                          <ChoiceGroup
                            options={choiceOptions}
                            selectedKey={selectedChoice}
                            onChange={handleChoiceChange}
                          />
                        </div>
                      );
                    })}
                  </ol>
                ) : (
                  <div id="MitigateDocEditorDiv14" style={{ textAlign: "center", marginTop: "50px" }}>
                    <span id="MitigateDocEditorSpan37">No Risk Available</span>
                  </div>
                )}
              </div>
            )}
            {showAll && showAltClauseButton.all && (
              <PrimaryButton
                style={{
                      background: "linear-gradient(45deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                      color: "black",
                      fontWeight: "400",
                      border: "none",
                      marginTop: "15px",
                      marginLeft: "10px"
                    }}
                onClick={() => {
                  handleOpenPanel("all");
                }}>
              {"Search Alternative Clauses"}
              <img src={AiStars} alt="AI Stars" width={20} height={20} style={{marginLeft:'5px'}}/>
              </PrimaryButton>
            )}
            {!showAll && (
              <div id="MitigateDocEditorDiv15" className={"MitigateRightDivBody"}>
                <ol id="MitigateDocEditorOl39" style={{ paddingRight: "5px", marginTop: "0px", paddingLeft: "22px" }}>
                  {selectedRowData && (
                    <div id="MitigateDocEditorDiv16" key={selectedRowData.GUID} style={{ paddingTop: "10px" }}>
                      <li id="MitigateDocEditorLi41" style={{ fontWeight: "bold", color: "var(--layoutTextColor)" }}>
                        {selectedRowData.Risk}
                      </li>

                      <div
                        id="MitigateDocEditorDiv17"
                        style={{ padding: "10px 0 0 10px", color: "var(--layoutTextColor)" }}
                      >
                        {selectedRowData.Clause}
                      </div>
                    </div>
                  )}
                </ol>

                {showAltClauseButton.single && !RiskTaskData?.Status && (
                  <PrimaryButton
                    style={{
                      background: "linear-gradient(45deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                      color: "black",
                      fontWeight: "400",
                      border: "none",
                      marginLeft: "15px"
                    }}
                    onClick={() => {
                      handleOpenPanel("single");
                    }}>
               {"Search Alternative Clauses"}
               <img src={AiStars} alt="AI Stars" width={20} height={20} style={{marginLeft:'5px'}}/>
                  </PrimaryButton>
                )}

                {isRiskFromTaskPanel && (
                  <div style={{ padding: "10px" }}>
                    <Dropdown
                      label="Status"
                      required
                      placeholder="Select Status"
                      options={statusOptions}
                      selectedKey={selectedRowData?.Status || null}
                      responsiveMode={ResponsiveMode.large}
                      onChange={(_, select) => {
                        setselectedRowData((prev) => ({ ...prev, Status: select.key }));
                      }}
                    />

                    <TextField
                      placeholder="Enter Comments"
                      label="Comments"
                      value={RiskComments}
                      rows={4}
                      autoAdjustHeight
                      multiline
                      onChange={(_, newValue) => setRiskComments(newValue)}
                      required
                    />
                    <PrimaryButton
                      style={{ margin: "10px 0" }}
                      onClick={() => {
                        updateRiskTask();
                      }}
                      text={"Submit"}
                    ></PrimaryButton>
                  </div>
                )}
              </div>
            )}
          </div>
          {isClausePanelOpen && (
            <Panel
              isOpen={isClausePanelOpen}
              //   onDismiss={()=>{setisClausePanelOpen(false)}}
              onDismiss={handlePanelClose}
              type={PanelType.medium}
              headerText={"Search Clauses"}
              closeButtonAriaLabel="Close"
            >
              <div id="SweetAlertUpdate">
                {AlternetClauseLoader ? (
                  <div id="MitigateDocEditorDiv18">
                    <Spinner
                      size={SpinnerSize.large}
                      style={{ marginTop: "35%" }}
                      label={"Please wait fetching data from AI... "}
                    />
                  </div>
                ) : (
                  <div id="MitigateDocEditorDiv19" style={{ position: "relative" }}>
                    <div>
                      <Label>{"Existing Clause"}</Label>
                      <TextField
                        multiline
                        value={selectedClause}
                        rows={5}
                        autoAdjustHeight
                        disabled
                        onChange={(_, newValue) => setselectedClause(newValue)}
                        required
                      />
                    </div>

                    {AzureAITogleValue && (
                      <div id="MitigateDocEditorDiv20">
                        <div id="MitigateDocEditorDiv21" className={"alternetclauseDiv"}>
                          <Label>{"Alternative Clauses by AI:"}</Label>
                          {showChevronIcon.AI && (
                            <div id="MitigateDocEditorDiv22" style={{ padding: "5px 0 0 0", cursor: "pointer" }}>
                              <Icon
                                iconName={showChevronIcon.AI == "down" ? "ChevronDown" : "ChevronUp"}
                                styles={{
                                  root: {
                                    color: "var(--layoutIconColor)",
                                    fontWeight: "600",
                                  },
                                }}
                                onClick={() => {
                                  AltClauseToggle("AI");
                                }}
                              />
                            </div>
                          )}
                        </div>
                        {showChevronIcon.AI == "down" ? (
                          <div id="MitigateDocEditorDiv23">
                            <ChoiceGroup
                              options={textchoices}
                              onChange={onChangeConditions}
                              selectedKey={conditionValue}
                            />

                            {/* {conditionValue ? <PrimaryButton
                        // onClick={updatechoicetext.bind(this)}
                        style={{marginTop: "10px" }}
                        onClick={selectClause}
                        text={"Select"}
                    >
                    </PrimaryButton>:<></>} */}
                          </div>
                        ) : contentNotFound ? (
                          <div className='NoDataFound'>No data found</div>
                        ): null}
                      </div>
                    )}
                    {clauseFromLib.length == 0 && (
                      <div id="MitigateDocEditorDiv24" className={"alternetclauseDiv"}>
                        <Link
                          style={{ cursor: "pointer", marginTop: "10px", fontWeight: "600" }}
                          onClick={() => {
                            setshowClauseModal({ inPanel: true, matchFound: true });
                          }}
                        >
                          {"Get Alternative Clauses from Clause Library"}
                        </Link>
                      </div>
                    )}
                    {clauseFromLib.length > 0 && (
                      <div id="MitigateDocEditorDiv25">
                        <div id="MitigateDocEditorDiv26" className={"alternetclauseDiv"}>
                          <div id="MitigateDocEditorDiv27" style={{ marginTop: "5px" }}>
                            <Label
                            // style={{cursor: "pointer"}}
                            // onClick={()=>{setshowClauseModal({inPanel:true,matchFound:true})}}
                            >
                              {"Alternative Clauses from Clause Library:"}
                            </Label>
                          </div>
                          {showChevronIcon.Lib && (
                            <div id="MitigateDocEditorDiv28" style={{ padding: "12px 0 0 0", cursor: "pointer" }}>
                              <Icon
                                iconName={showChevronIcon.Lib == "down" ? "ChevronDown" : "ChevronUp"}
                                styles={{
                                  root: {
                                    color: "var(--layoutIconColor)",
                                    fontWeight: "600",
                                  },
                                }}
                                onClick={() => {
                                  AltClauseToggle("Lib");
                                }}
                              />
                            </div>
                          )}
                        </div>
                        {showChevronIcon.Lib == "down" && (
                          <div id="MitigateDocEditorDiv29">
                            <ChoiceGroup
                              options={clauseFromLib}
                              // selectedKey={selectedLibChoice?.key || null}
                              selectedKey={conditionValue == selectedLibChoice?.text ? selectedLibChoice?.key : null}
                              onChange={handleChoiceChangefromLib}
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {conditionValue && (
                      <div id="MitigateDocEditorDiv30">
                        <TextField
                          multiline
                          label={"Select Text"}
                          value={conditionValue || ""}
                          autoAdjustHeight
                          onChange={handleTextFieldChange}
                          // styles={{
                          //     fieldGroup: { width: '38.6rem' },
                          // }}
                        />

                        <Dropdown
                          label="Status"
                          required
                          placeholder="Select Status"
                          options={mitigateStatusOptions}
                          selectedKey={LegalUserRiskData?.Status || null}
                          responsiveMode={ResponsiveMode.large}
                          onChange={(_, select) => {
                            setLegalUserRiskData((prev) => ({ ...prev, Status: select.key }));
                          }}
                        />

                        <TextField
                          placeholder="Enter Comments"
                          label="Comments"
                          value={LegalUserRiskData?.Comments}
                          rows={4}
                          autoAdjustHeight
                          multiline
                          onChange={(_, newValue) => setLegalUserRiskData((prev) => ({ ...prev, Comments: newValue }))}
                          required
                        />

                        <PrimaryButton
                          style={{ margin: "10px 0" }}
                          onClick={() => {
                            updateRiskMitigate();
                          }}
                          text={"Update"}
                        ></PrimaryButton>
                      </div>
                    )}
                    {showClauseModal.inPanel && (
                      <div id="MitigateDocEditorDiv31">
                        <Dialog
                          hidden={!showClauseModal}
                          onDismiss={() => {
                            setshowClauseModal({ inPanel: false, matchFound: false }),
                              setSelectedLibClause({ clauseType: "", Tags: "" }),
                              setShowErrors({ clauseType: false, tags: false });
                          }}
                          dialogContentProps={{
                            title: "Get from clause library",
                          }}
                        >
                          <div id="MitigateDocEditorDiv32" >
                            <Label required>{"Clause Type"}</Label>
                              <Select
                                placeholder={"Select Clause Type"}
                                options={clauseTypesOptions}
                                value={clauseTypesOptions?.find((ele) => ele.value == selectedLibClause.clauseType)}
                                onChange={(e) => handleClauseChange(e, "clauseType")}
                                maxMenuHeight={100}
                                // styles={customStyles}
                              />
                              {showErrors.clauseType && (
                                <MessageBar
                                  messageBarType={MessageBarType.error}
                                  styles={{
                                    content: { display: "flex !important", justifyContent: "flex-start !important" },
                                  }}
                                >
                                  Clause Type is required.
                                </MessageBar>
                              )}
                            <Label required> {"Tags"}</Label>
                              <TextField
                                placeholder={"Enter Tags"}
                                value={selectedLibClause.Tags}
                                onChange={(e) => handleClauseChange(e, "Tags")}
                                // style={{width:"10rem"}}
                              />
                              {showErrors.tags && (
                                <MessageBar
                                  messageBarType={MessageBarType.error}
                                  styles={{
                                    content: { display: "flex !important", justifyContent: "flex-start !important" },
                                  }}
                                >
                                  Tags are required.
                                </MessageBar>
                              )}
                          </div>
                          <div
                            id="MitigateDocEditorDiv36"
                            style={{ display: "flex", justifyContent: "center", gap: "15px", marginTop: "15px" }}
                          >
                            <PrimaryButton onClick={handleSubmit} text={"Submit"} />
                            <DefaultButton
                              onClick={() => {
                                setshowClauseModal({ inPanel: false, matchFound: true }),
                                  setSelectedLibClause({ clauseType: "", Tags: "" }),
                                  setShowErrors({ clauseType: false, tags: false });
                              }}
                              text={"Cancel"}
                            />
                          </div>
                        </Dialog>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Panel>
          )}
          {!isRiskFromTaskPanel && IsShowUpdate && (
            <PrimaryButton text="Update in Contract" style={{ margin: "10px 0" }} onClick={updateDraftDocument} />
          )}
        </div>
      ) : (
        <div>No clause is currently available for review</div>
      )}
    </>
  );
};

export default RequestRisks;
